import { writable } from 'svelte/store';
import type { UserSession, InspectionRecord, RoleType } from './types';
import type { StorageMode, StorageAdapter } from './storage/types';

export const session = writable<UserSession | null>(null);
export const currentStep = writable<'selection' | 'checklist' | 'summary' | 'print'>('selection');
export const records = writable<Record<string, InspectionRecord>>({});
export const selectedChecklistId = writable<string | null>(null);
// 暫存使用者選擇的角色（在選單頁還沒建立 session 時使用）
export const tempSelectedRole = writable<RoleType | null>(null);
// 字型大小設定（像素），預設 28px
export const fontSize = writable<number>(28);
// 控制是否在頁面中間顯示時鐘（若為 true，header 上的時鐘會隱藏）
export const centerClockVisible = writable<boolean>(false);

// Storage mode indicator: 'remote' = API, 'local' = localStorage
export const storageMode = writable<StorageMode>('local');
// Whether the storage adapter is currently syncing data
export const storageSyncing = writable<boolean>(false);
// The active storage adapter instance (set during app init)
export const storageAdapter = writable<StorageAdapter | null>(null);

// Committee comments store (keyed by checklist ID)
export const committeeComments = writable<Record<string, string>>({});

// 暫存使用者在選擇角色頁面輸入的稱呼（在建立 session 前使用）
// 同步到 localStorage，避免在切換畫面或重繪時遺失使用者輸入
let initialTempName = '';
try {
	if (typeof localStorage !== 'undefined') {
		initialTempName = localStorage.getItem('dmy_name') ?? '';
	}
} catch (e) {
	initialTempName = '';
}

export const tempSelectedName = writable<string>(initialTempName);

tempSelectedName.subscribe(val => {
	try {
		if (typeof localStorage !== 'undefined') {
			if (val) localStorage.setItem('dmy_name', val);
			else localStorage.removeItem('dmy_name');
		}
	} catch (e) {
		// ignore (SSR or restricted env)
	}
});
